import { OpportunitySchema } from '@features/opportunities/modules/core/models/schema-property-definition';

export namespace DriversLicence {
  export interface SchemaPropertyDefinition {
    expiry: OpportunitySchema.StringPropertyDefinition;
    number: OpportunitySchema.StringPropertyDefinition;
    cardNumber: OpportunitySchema.StringPropertyDefinition;
    issuer: OpportunitySchema.OptionsPropertyDefinition;
    type: OpportunitySchema.OptionsPropertyDefinition;
  }

  export interface SchemaContract {
    expiry?: string | null;
    number?: string | null;
    cardNumber?: string | null;
    issuer?: string | null;
    type?: string | null;
  }

  export interface Model {
    expiry: string | null;
    number: string | null;
    cardNumber: string | null;
    issuer: string | null;
    type: string | null;
  }

  export function toModel(contract: SchemaContract): Model {
    return {
      expiry: contract.expiry ?? null,
      number: contract.number ?? null,
      cardNumber: contract.cardNumber ?? null,
      issuer: contract.issuer ?? null,
      type: contract.type ?? null
    };
  }

  export function toSchemaContract(
    model: Partial<Model>
  ): Partial<SchemaContract> {
    return model as SchemaContract;
  }
}
